// Auth
export const LOGIN_REQUEST = "login_request";
export const LOGIN_SUCCESS = "login_success";
export const LOGIN_FAILURE = "login_failure";
export const LOGOUT_SUCCESS = "logout_success";
export const FETCHING = "fetching";
export const NOT_FETCHING = "not_fetching";
export const GET_ME = "get_me";

// Error
export const SET_ERROR = "set_error";
export const REMOVE_ERROR = "remove_error";
